(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rl-arrival"] && !Shopify.designMode) return;
  try {
    
  // Hero video: the photo is the LCP; the video starts only after the page has loaded and fades in over it.
  (() => {
    const v = document.querySelector('.rl-arrival__video[data-src]');
    if (!v || matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
    const start = () => {
      v.src = v.dataset.src;
      v.addEventListener('playing', () => v.classList.add('is-playing'), { once: true });
      v.play().catch(() => {});
    };
    if (document.readyState === 'complete') setTimeout(start, 400); else addEventListener('load', () => setTimeout(start, 400), { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rl-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', function (e) {
    var box = e.target.closest && e.target.closest('[data-rl-faq-search]'); if (!box) return;
    var q = box.value.trim().toLowerCase(), sec = box.closest('.rl-faq');
    sec.querySelectorAll('.rl-faq__item').forEach(function (d) { var hit = !q || d.textContent.toLowerCase().indexOf(q) > -1; d.hidden = !hit; if (q && hit) d.open = true; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rl-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Desktop: menus always open; mobile: accordions (closed). Keeps one markup, accessible without JS.
    const mq = matchMedia('(min-width: 750px)');
    const sync = () => document.querySelectorAll('.rl-foot__menu').forEach((d) => { d.open = mq.matches; });
    sync(); mq.addEventListener?.('change', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rl-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const d = document.getElementById('rl-pop');
    if (!d || typeof d.showModal !== 'function') return;
    const KEY = 'rl_pop_v1';
    const remember = () => { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} };
    const open = () => { if (!d.open) { d.showModal(); requestAnimationFrame(() => d.classList.add('is-in')); } };
    const close = () => { d.classList.remove('is-in'); remember(); setTimeout(() => d.open && d.close(), 260); };
    d.addEventListener('click', (e) => {
      if (e.target === d || e.target.closest('[data-rl-pop-close]')) { close(); return; }
      const c = e.target.closest('[data-rl-copy]');
      if (c && navigator.clipboard) navigator.clipboard.writeText(c.dataset.rlCopy).then(() => { c.textContent = d.dataset.rlCopied || 'Copiado ✓'; });
    });
    d.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    if (d.querySelector('[data-rl-pop-posted]') || d.querySelector('.rl-pop__error')) { remember(); open(); return; }
    if (d.hasAttribute('data-editor')) {
      document.addEventListener('shopify:section:select', (e) => { if (d.closest('.shopify-section')?.id.endsWith(e.detail.sectionId)) open(); });
      document.addEventListener('shopify:section:deselect', () => d.open && d.close());
      return;
    }
    if (/\/(cart|checkout|account|policies|apps)/.test(location.pathname)) return;
    let seen = 0;
    try { seen = Number(localStorage.getItem(KEY)) || 0; } catch (e) {}
    if (Date.now() - seen < 7 * 864e5) return;
    // Never interrupt a purchase: skip if the cart has items or any drawer/dialog is open at that moment.
    setTimeout(async () => {
      if (document.querySelector('dialog[open]:not(#rl-pop), cart-drawer-component[open], .cart-drawer[open]')) return;
      try { const c = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json(); if (c.item_count > 0) return; } catch (e) {}
      open();
    }, (Number(d.dataset.delay) || 8) * 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rl-reviews"] && !Shopify.designMode) return;
  try {
    
  // UGC videos play muted only while visible; never autoplay with reduced motion.
  (() => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) e.target.play().catch(() => {}); else e.target.pause();
    }), { threshold: 0.6 });
    const watch = () => document.querySelectorAll('video.rl-rev__media').forEach((v) => io.observe(v));
    watch();
    document.addEventListener('shopify:section:load', watch);
  })();

  (() => {
    const initialized = new WeakSet();
    const mount = () => document.querySelectorAll('.rl-rev[data-auto-carousel]').forEach(section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const track = section.querySelector('.rl-rev__track');
      const button = section.querySelector('.rl-rev__pause');
      if (!track) return;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = motion.matches;
      let hovering = false;
      let visible = false;
      let holdUntil = 0;
      const updateButton = () => {
        if (!button) return;
        button.setAttribute('aria-pressed', String(userPaused));
        button.textContent = userPaused ? button.dataset.play : button.dataset.pause;
      };
      if (button) {
        button.dataset.pause = button.textContent.trim();
        button.dataset.play = section.dataset.playLabel;
        button.addEventListener('click', () => { userPaused = !userPaused; updateButton(); });
      }
      track.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hovering = true; });
      track.addEventListener('pointerleave', () => { hovering = false; });
      track.addEventListener('pointerdown', () => { holdUntil = Date.now() + 12000; }, {passive:true});
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, {threshold:0.25});
      observer.observe(track);
      const timer = setInterval(() => {
        if (!section.isConnected) { clearInterval(timer); observer.disconnect(); return; }
        if (!visible || userPaused || hovering || motion.matches || document.hidden || Date.now() < holdUntil || track.contains(document.activeElement)) return;
        const card = track.querySelector('.rl-rev__card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16);
        const end = track.scrollWidth - track.clientWidth;
        track.scrollTo({left:track.scrollLeft >= end - 8 ? 0 : Math.min(end, track.scrollLeft + step), behavior:'smooth'});
      }, 4500);
      updateButton();
    });
    mount();
    document.addEventListener('shopify:section:load', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rl-sample-toast"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start() {
      var t = document.querySelector('[data-rl-toast]'), j = document.querySelector('[data-rl-toast-items]');
      if (!t || !j || t.dataset.on) return;
      t.dataset.on = '1';
      var items = []; try { items = JSON.parse(j.textContent); } catch (e) { return; }
      if (!items.length) return;
      var cur = document.querySelector('[data-rl-toast-current]');
      if (cur) { try { var c = JSON.parse(cur.textContent); var others = items.filter(function (x) { return x.u !== c.u; }); items = [];
        others.forEach(function (o) { items.push(c, o); }); if (!items.length) items = [c]; } catch (e) {} }
      // Buyers of the visitor's market (founder 2026-10-21). UK list = design mockup only (never on the main theme).
      var uk = t.dataset.rlMarket === 'uk';
      var people = uk
        ? [['Emma W.', 'London'], ['Sophie T.', 'Manchester'], ['Olivia H.', 'Birmingham'], ['Charlotte B.', 'Leeds'], ['Amelia R.', 'Bristol'],
           ['Jessica M.', 'Glasgow'], ['Lucy P.', 'Edinburgh'], ['Hannah C.', 'Liverpool'], ['Grace D.', 'Cardiff'], ['Ellie S.', 'Brighton'],
           ['Chloe K.', 'York'], ['Megan F.', 'Bath'], ['Holly J.', 'Norwich'], ['Laura G.', 'Nottingham']]
        : t.dataset.rlMarket === 'mx'
        ? [['Daniela', 'Ciudad de México'], ['Valeria', 'Monterrey'], ['Fernanda', 'Guadalajara'], ['Ximena', 'Querétaro'], ['Andrea', 'Mérida'],
           ['Mariana', 'Puebla'], ['Regina', 'San Miguel de Allende'], ['Sofía', 'Oaxaca'], ['Paola', 'Cancún'], ['Gabriela', 'Tijuana']]
        : [['Lucía', 'Madrid'], ['Carmen', 'Sevilla'], ['Paula', 'Valencia'], ['Nerea', 'Barcelona'], ['Alba', 'Málaga'],
           ['Marta', 'Bilbao'], ['Rocío', 'Granada'], ['Elena', 'Zaragoza'], ['Inés', 'San Sebastián'], ['Claudia', 'Alicante']];
      var sizes = ['S', 'M', 'M', 'L', 'XS', 'M', 'L', 'S'], mins = [2, 4, 1, 7, 3, 9, 5, 12], i = 0;
      // Mexico: the size label the page shows (data-rl-size-mx="EU|MX" on the size buttons), e.g. 37 -> 23.5.
      var mxMap = {}; document.querySelectorAll('[data-rl-size-mx]').forEach(function (e) { var p = e.dataset.rlSizeMx.split('|'); mxMap[p[0]] = p[1]; });
      function mxSize(s) { return uk ? s : (mxMap[s] || s); }
      var img = t.querySelector('[data-rl-toast-img]'), txt = t.querySelector('[data-rl-toast-text]'), sub = t.querySelector('[data-rl-toast-sub]');
      function show() {
        if (document.querySelector('dialog[open], header-drawer details[open], .cart-drawer[open]')) { t.classList.remove('is-on'); return; }
        var p = people[i % people.length], it = items[i % items.length];
        var sz = mxSize(it.s && it.s.length ? it.s[(i * 3 + 2) % it.s.length] : sizes[i % sizes.length]);   // the product's own sizes (shoes: 38, not S)
        img.src = it.i;
        txt.innerHTML = uk
          ? '<b>' + p[0] + '</b> from ' + p[1] + ' bought ' + it.t.replace(/</g, '&lt;') + ' · size ' + sz
          : '<b>' + p[0] + '</b> de ' + p[1] + ' compró ' + it.t.replace(/</g, '&lt;') + ' · talla ' + sz;
        sub.textContent = uk
          ? mins[i % mins.length] + ' min ago · Free tracked delivery with Royal Mail'
          : 'hace ' + mins[i % mins.length] + ' min · Envío Premium Gratis';
        t.classList.add('is-on'); setTimeout(function () { t.classList.remove('is-on'); }, 5200); i++;
      }
      setTimeout(function () { show(); setInterval(show, 11000); }, 6000);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rl-wearpack"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.rl-wp__opt'); if (!b) return;
    var box = b.closest('[data-rl-finder]');
    box.querySelectorAll('.rl-wp__opt').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
    box.querySelector('[data-rl-out]').textContent = b.dataset.rlAnswer;
  });

  } catch(e) { console.error(e); }
})();
})();
